var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",class:{ relative: _vm.relative }},[_vm._t("default"),_c('HollowDotsSpinner',{attrs:{"animation-duration":1000,"size":100,"color":'#EE3624'}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }